// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EloJ","buttons":"styles_buttons__3pd5W"};